import { z } from 'zod'

import type { QuestFormInfo, UniquenessPolicy } from './types'

export const buildCreateRunRecord = (
  uniquenessPolicy: UniquenessPolicy,
  identifier: string,
  infoResponses: Record<string, string>
): { email?: string; registration_number?: string; info_responses: Record<string, string> } => ({
  ...(uniquenessPolicy === 'email' ? { email: identifier } : { registration_number: identifier }),
  info_responses: infoResponses
})

export const buildQuestFormSchema = (formInfos: QuestFormInfo[]) =>
  z.object({
    identifier: z.string().min(1),
    info_responses: z.record(z.string()).superRefine((values, ctx) => {
      formInfos
        .filter(info => !info.optional)
        .forEach(info => {
          if (!values[info.slug]?.trim()) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: [info.slug],
              message: 'required'
            })
          }
        })
    })
  })

export type QuestFormValues = z.infer<ReturnType<typeof buildQuestFormSchema>>
